

export type LoanTermsSelectionWithInputValue = number | null;
